import { buildCollection, buildProperty } from "@firecms/core";
import { HomeButton } from "../components/HomeButton";

export type IssuedCoupon = {
    campaign_id: string;
    campaign_name: string;
    user_id: number;
    discount_type: string;
    discount_value: string;
    is_redeemed: boolean;
    redeemed_at: Date;
    redeemed_by: string;
    purchase_id: string;
    created_at: Date;
};

export const issuedCouponsCollection = buildCollection<IssuedCoupon>({
    id: "issued_coupons",
    name: "Issued Coupons",
    singularName: "Issued Coupon",
    path: "issued_coupons",
    icon: "Token",
    group: "Promotions",
    Actions: HomeButton,
    description: "Issued coupons and their redemption status",
    permissions: {
        edit: false,
        create: false,
        delete: false,
    },
    properties: {
        campaign_id: buildProperty({
            name: "Campaign ID",
            dataType: "string",
            readOnly: true,
        }),
        campaign_name: buildProperty({
            name: "Campaign",
            dataType: "string",
            readOnly: true,
        }),
        user_id: buildProperty({
            name: "User ID",
            dataType: "number",
            readOnly: true,
        }),
        discount_type: buildProperty({
            name: "Discount Type",
            dataType: "string",
            readOnly: true,
            enumValues: {
                percent: "Percentage",
                flat: "Flat Amount",
            },
        }),
        discount_value: buildProperty({
            name: "Discount Value",
            dataType: "string",
            readOnly: true,
        }),
        is_redeemed: buildProperty({
            name: "Redeemed",
            dataType: "boolean",
            readOnly: true,
            columnWidth: 100,
        }),
        redeemed_at: buildProperty({
            name: "Redeemed At",
            dataType: "date",
            mode: "date_time",
            readOnly: true,
        }),
        redeemed_by: buildProperty({
            name: "Redeemed By",
            dataType: "string",
            readOnly: true,
        }),
        purchase_id: buildProperty({
            name: "Purchase ID",
            dataType: "string",
            readOnly: true,
        }),
        created_at: buildProperty({
            name: "Created At",
            dataType: "date",
            mode: "date_time",
            readOnly: true,
        }),
    },
    propertiesOrder: [
        "campaign_name",
        "user_id",
        "is_redeemed",
        "discount_type",
        "discount_value",
        "redeemed_at",
        "created_at",
    ],
});
